import React from 'react'

export default class RentalUrl  {

    // Returns search form query params
    // Used for redirects, and ajax requests
    static searchQuery = (r) => {
        return RentalUrl.toQueryString(RentalUrl.searchObject(r))
    }


    // Encode an object to query string
    static toQueryString = (paramsObject) => {
        return Object
            .keys(paramsObject)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
            .join('&')

    }

    // Params object from search form props
    static searchObject = (r) => {
       return {
            start_location: r.start_location,
            end_location: (r.end_location || 'false'),
            start_date: r.start_date,
            end_date: r.end_date,
            start_hour: r.start_hour,
            end_hour: r.end_hour,
            locale: r.locale
        }
    }

    
}
